import {confirmPlus} from 'admin/common/custom_confirm'

class PermissionManager extends HTMLElement {
  constructor() {
    super();
    let sd = this.attachShadow({mode: 'open'});
    //Named slots would simplify things, but DataTables isn't doesn't seem to work with named slots
    let slot = document.createElement('slot');
    let cb = document.createElement('input');
    let editor_slot = document.createElement('slot');
    editor_slot.name = 'editor';
    let editor = this._editor = document.createElement('permission-editor');
    editor.slot = 'editor';
    sd.append(slot, editor_slot);
  }

  connectedCallback(){
    let style = document.createElement('style');
    style.textContent = `
permission-editor {
  position: absolute;
  top: 120px;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: white;
  z-index: 100;
  margin-left: 2em;
}

permission-editor[edit] {
  opacity: 1;
  pointer-events: auto;
}

permission-editor:not([edit]) {
  opacity: 0;
  pointer-events: none;
}

table {
  width:100%;
}

.rpm_col_1 {
  width: 2.5in
}

.rpm_col_2 {
  width: calc(100%-3in);
}

.rpm_col_3 {
  width: 0.5in
}

.badge {
  margin: 0.25em;
}

.rp-edit-button {
  user-select: none;
  cursor: pointer;
}

.rp-del-button {
  user-select: none;
  cursor: pointer;
  margin-left: 1rem;
}

.form-control {
  width: calc(100% - 5em);
  float: left;
  margin-right: 1em;
}`;

    //create table and initial contents
    let tbl = this._table = document.createElement('table');
    tbl.className = "table dataTable no-footer table-striped";
    tbl.innerHTML = `
<colgroup>
	<col class=rpm_col_1>
	<col class=rpm_col_2>
	<col class=rpm_col_3>
</colgroup>
<thead>
  <tr>
    <th>Role</th>
    <th>Permissions</th>
    <th>Actions</th>
  </tr>
</thead>
`
    this._tbody = document.createElement('tbody');
    tbl.append(this._tbody);
    this.append(style, tbl, this._editor); //added to the light-dom and included with slot for ease of use with jQuery
    this.buildTable();
  }

  async fetchRoles(){
    let res = await fetch('/admin/role_permissions/all_roles');
    let json = await res.json();
    return json;
  }

  async buildTable(id){

    let tbdy = this._tbody;
    tbdy.innerHTML = '';
    let row = [];
    let roles = await this.fetchRoles();
    let ret;
    let t = 'test';
    for(let role of roles){
      if(role.id == id) ret = role;

      //build row and cells;
      let row = document.createElement('tr');
      tbdy.append(row);
      let c1 = document.createElement('td');
      let c2 = document.createElement('td');
      let c3 = document.createElement('td');
      row.append(c1, c2, c3);

      //build cell contents
      c1.innerText = role.display_name;
      let reb = document.createElement('a');
      reb.className = 'rp-edit-button';
      reb.innerText = 'Edit';
      reb.title = `Edit ${role.display_name}`;
      reb.onclick = () => this._editor.setAttribute('edit',role.id);
      c3.append(reb);
      let perm = [];

      //build permission "pills"
      for(let grp of role.group_role_permissions){
        let rp = grp.role_permission;
        let prm = document.createElement('span');
        prm.className = "badge badge-pill badge-info";
        prm.title = rp.description;
        prm.innerText = rp.name;
        c2.append(prm);
      }
    }

    //Convet to DataTable
    $(this._table).DataTable();
    return ret;
  }

  edit(role_name, role_id){

  }
}

customElements.define('permission-manager', PermissionManager);



class PermissionEditor extends HTMLElement {

  static get observedAttributes() {return ['edit']; }

  attributeChangedCallback(attr, oldValue, newValue) {
    if (attr == 'edit') {
      this.edit = newValue;
    }
  }

  set edit(id){
    if( this.getAttribute('edit') !== id) this.setAttribute('edit');
    this.updateUI(id);
  }

  constructor() {
    super();
    let sd = this.attachShadow({mode: 'open'});
    this._roleId = null;
    this._roleLabel = document.createElement('span');
    let cancel = this._cancel = document.createElement('span');
    sd.innerHTML =`
<style>
  #cancel {
    font-weight: bold;
    /* color: red; */
    cursor: pointer;
    user-select: none;
    margin-left: -1em;
  }
  h3 {
    margin-bottom: 10px;
    font-size: 18px;
    font-weight: 600;
    color: #434a54;
    padding: 0px;
    line-height: 1.1;
  }
  div{
    width: 50%;
    margin-left:25%;
  }
  footer {
    text-align: right;
  }
</style>
<div class='col-lg-7 col-md-12 col-lg-offset-2'>
  <header>
    <h3><slot id=cancel name=chevron></slot> Editing: <span id=role_label></span></h3>
    <slot name=select></slot>
  </header>
  <main>
    <h4>Current Permissions:</h4>
    <slot></slot>
  </main>
  <footer>
    <slot name=cancel_button></slot>
  </footer>
</div>
    `
  }

  connectedCallback(){
    this.buildSelect();
    let add = document.createElement('button');
    add.className = 'btn btn-success';
    add.type='button';
    add.onclick = this.addPermission.bind(this);
    add.innerText = 'Add';
    add.slot = 'select';
    let cancel = this.cancel = document.createElement('span');
    cancel.className = 'fa fa-chevron-left';
    cancel.slot = 'chevron';
    let cancelButton = this.cancelButton = document.createElement('button');
    cancelButton.type = 'button';
    cancelButton.innerText = cancelButton.title = cancel.title = 'Cancel';
    cancelButton.onclick = cancel.onclick = this.stopEditing.bind(this);
    cancelButton.slot = 'cancel_button';
    cancelButton.className = 'btn btn-danger pull-right';
    this._roleLabel = this.shadowRoot.getElementById('role_label');
    this._permList = document.createElement('div');
    this.append(this._selector, add, this._permList, this.cancel, this.cancelButton);
  }

  async updateUI(id){
    this._permList.innerHTML = '';
    this._roleId = id;
    if(id){
      let role = await this.parentNode.buildTable(id);
      this._roleLabel.innerText = role.display_name||'';
      //List permissions
      for(let p of role.group_role_permissions) this.listPermission(p.id, p.role_permission.name, p.role_permission.description, role.name);
    }
  }

  listPermission(id, name, description, role){
    let pill = document.createElement('span');
    pill.className = "badge badge-pill badge-info";
    pill.innerText = name;
    pill.title = description;
    let del = document.createElement('span');
    del.className = 'fa fa-times rp-del-button';
    del.onclick = async e => {
      let conf = await confirmPlus(`Are you sure you want to remove the Permission ${name} from Role ${role}`, 'Remove Permission');

      if(conf) {conf = await confirmPlus(`Are you 100% sure!!!`, 'Remove Permission');}
      if(conf)this.removePermission(id, e);
    }
    del.title = 'Remove ' + description;
    pill.append(del);
    this._permList.append(pill);
  }

  editRole(role_id, role_name){
    this._roleId = role_id;
    this._roleName = role_name;
    this.setAttribute('editing');
  }

  stopEditing(){
    this.removeAttribute('edit');
    this._roleId = null;
    this._roleName = '';
    this._permList.innerHTML = '';
  }

  async addPermission(){
    let res = await fetch(`/admin/role_permissions/`,{
      headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                'Content-type': 'application/json'},
      method: 'POST',
      body: `{"role_permission_id": ${this._selector.value}, "group_role_name_id": ${this._roleId}}`
    });
    this.updateUI(this._roleId);
  }

  async removePermission(id, e){
    let res = await fetch(`/admin/role_permissions/${id}`,{
      headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                'Content-type': 'application/json'},
      method: 'DELETE',
      body: `{"role_permission_id":${id}}`
    });
    this.updateUI(this._roleId);
  }

  async buildSelect(){
    let select = this._selector = document.createElement('select');
    select.className = 'form-control';
    select.slot = 'select';
    let res = await fetch('/admin/role_permissions/all_permissions');
    let json = await res.json();
    for(let perm of json){
      let opt = document.createElement('option');
      opt.innerText = perm.name;
      opt.value = perm.id;
      opt.title = perm.description;
      select.append(opt);
    }
  }
}

customElements.define('permission-editor', PermissionEditor);
